<template>
    <footer class="footer has-background-white">
        <div class="container">
            <div class="columns">
                <div class="column">
                    &nbsp;
                </div>

                <div class="column">
                    <h5 class="is-uppercase">{{$t('layout.footer.skills.title')}}</h5>

                    <ul>
                        <li v-for="(skill, index) in skillLinks" class="footer-link" :key="index">
                            <router-link :to="{name: 'skills.skill', params: {group: skill.group, skill: skill.name}}">
                                {{$t(`skills.${skill.name}.name`)}}
                            </router-link>
                        </li>
                    </ul>
                </div>

                <div class="column">
                    <h5 class="is-uppercase">{{$t('layout.footer.pages.title')}}</h5>

                    <ul class="list-unstyled">
                        <li>
                            <router-link :to="{name: 'about'}" class="footer-link">{{$t('pages.about.title')}}</router-link>
                        </li>

                        <li>
                            <router-link :to="{ name: 'customers.register' }" class="footer-link">{{$t('global.actions.register')}}</router-link>
                        </li>

                        <li>
                            <router-link :to="{name: 'new-student'}" class="footer-link">{{$t('pages.new-student.title')}}</router-link>
                        </li>

                        <li>
                            <router-link :to="{name: 'contact'}" class="footer-link">{{$t('pages.contact.title')}}</router-link>
                        </li>

                        <li>
                            <router-link :to="{name: 'terms'}" class="footer-link">{{$t('pages.terms.title')}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import NewsletterService from '@/taskflex/newsletters/services/NewsletterService';

    export default {
        data() {
            return {
                email: null,
                isSubscribing: false,
                success: false,
                error: false,
                skillLinks: [
                    {
                        group: 'finance',
                        name: 'bookkeeping',
                    },
                    {
                        group: 'web',
                        name: 'simple-website',
                    },
                    {
                        group: 'marketing',
                        name: 'market-analysis',
                    },
                    {
                        group: 'graphic',
                        name: 'logo',
                    },
                ],
            };
        },

        methods: {
            async submit() {
                this.error = false;

                if (this.isSubscribing || !await this.$validator.validateAll()) {
                    return;
                }

                this.isSubscribing = true;

                const options = {
                    email: this.email,
                };

                NewsletterService.subscribePublic(options, () => {
                    this.isSubscribing = false;
                    this.success = true;
                }, () => {
                    this.isSubscribing = false;
                    this.error = true;
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/global/layout/Footer.vue